// the website path to the email verification page
export const emailVerificationSitePath = 'email-verification';

// the api path to the email verification page
export const emailVerificationApiUrlPathParts = ['users', 'email-verification'];

export const emailVerificationParam = 'token';

// the website path to do voucher uploads
export const voucherUploadSitePath = 'voucher-upload';
